import React from "react";

const UploadDocIcon = ({ size = 48, color = "#000", strokeWidth = 3 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Arrow */}
      <path d="M12 15V3" />
      <path d="M7 8L12 3L17 8" />

      {/* Tray */}
      <path d="M4 15V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V15" />
    </svg>
  );
};

const DownloadIcon = ({ size = 48, color = "#6B7280", strokeWidth = 3 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Arrow */}
      <path d="M12 3V15" />
      <path d="M7 10L12 15L17 10" />

      {/* Tray */}
      <path d="M4 15V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V15" />
    </svg>
  );
};

export { UploadDocIcon, DownloadIcon };
